module.exports = __webpack_public_path__ + "img/semas_stamp.2406039a.png";